<template>
  <div class="flex-col justify-start page">
    <div class="flex-col justify-start section">
      <div class="flex-col justify-start items-center relative section_2">
        
        <div class="flex-col group space-y-26">
          <div class="toptitle">
            <img
              class = "shrink-0 image_01"
              src="../../assets/turn_logo.png"
            />
          </div>
          <div class="flex-row group_2 space-x-779">
            <div class="flex-row self-center" style="flex: 1">
              <div class="flex-col justify-start items-center text-wrapper">
                <span class="font_1 text">提交文章</span>
              </div>
              <div
                class="flex-col justify-start items-center text-wrapper_2"
                @click="showClick"
              >
                <span class="font_1 text_2">查看报告</span>
              </div>
            </div>
            <div class="flex-row items-center self-start section_4">
              <span class="font_2" style="cursor: pointer" @click="toTaobao"
                >商家店铺</span
              >
              <div class="shrink-0 section_5"></div>
              <img
                class="shrink-0 image image_2"
                src="../../assets/d74a37279a8be9c88380ef8c061c1386.png"
              />
              <span
                class="font_2 text_3"
                style="cursor: pointer"
                @click="contactWW"
                >和我联系</span
              >
            </div>
          </div>
          <div
            class="flex-col justify-start items-center section_6"
            :class="showCheck == false ? 'nocheck' : ''"
          >
            <div class="article-box" v-if="!showCheck">
              <div class="formbox">
                <Form
                  ref="paper"
                  :model="paper"
                  :rules="ruleValidate"
                  :label-width="176"
                  class="leftline"
                >
                  <div class="one"></div>
                  <FormItem label="文章标题(Paper title)：" prop="title">
                    <Input
                      v-model="paper.title"
                      placeholder="请输入文章标题"
                      style="width: 366px"
                    ></Input>
                    <div class="waring">
                      <Icon
                        type="md-warning"
                      />请勿包含特殊符号（`_"'\/|:*?）或纯半角符号！
                    </div>
                  </FormItem>
                  <FormItem label="姓(Author's last name)：" prop="surname">
                    <Input
                      v-model="paper.surname"
                      placeholder="请输入作者姓氏"
                      style="width: 366px"
                    ></Input>
                    <div class="waring">
                      <Icon
                        type="md-warning"
                      />请勿包含特殊符号（`_"'\/|:*?）或纯半角符号！
                    </div>
                  </FormItem>
                  <FormItem label="名(Author's first name)：" prop="name">
                    <Input
                      v-model="paper.name"
                      placeholder="请输入作者名字"
                      style="width: 366px"
                    ></Input>
                    <div class="waring">
                      <Icon
                        type="md-warning"
                      />录入以上信息时请勿包含特殊符号（`_"'\/|:*?）或纯半角符号！
                    </div>
                  </FormItem>
                  <div class="fileradio" prop="type">
                    <RadioGroup v-model="paper.type" @on-change="typeChange">
                      <Radio label="content">内容上传</Radio>
                      <Radio label="file">文件上传</Radio>
                    </RadioGroup>
                  </div>
                </Form>
                <Form
                  :model="paper"
                  label-position="top"
                  class="form-bottom leftline"
                >
                  <div class="two"></div>
                  <FormItem label="论文(Thesis File)">
                    <Upload
                      :before-upload="handleUpload"
                      action="/"
                      :class="isdis == true ? 'disfile' : ''"
                      :disabled="isdis"
                      accept=".docx,.pdf,.doc"
                      class="uploadfile"
                    >
                      <Button class="selectfile">选择文件</Button>
                    </Upload>
                    <div v-if="file !== null" class="filename">
                      <span class="font_8" v-if="succData.sucYes == true" style="color: black">文件名: {{ file.name }}</span>
                      <span class="font_8" v-else-if="succData.sucYes == false" style="color: red">论文正在提交中，请稍等...</span>
                      <span class="font_8" v-else-if="succData.sucYes == 'large'" style="color: red">文件大于50M，请删除图片缩小文档后重新提交！！！</span>
                      <span class="font_8" v-else style="color: red">解析失败，请尝试提交pdf或复制内容提交，若还有问题，请删除图片后提交!!!</span>
                    </div>
                  </FormItem>
                  <FormItem label="文章内容(Paper content)：" prop="textarea">
                    <Input
                      v-model="paper.textarea"
                      type="textarea"
                      :autosize="{ minRows: 8, maxRows: 10 }"
                      :disabled="!isdis"
                      placeholder="请输入文章内容"
                    ></Input>
                  </FormItem>
                  <div class="three"></div>
                
                  <FormItem label="是否排除参考文献【排除后参考文献不计入重复率】">
                    <div class="excluradio" prop="exclude">
                      <RadioGroup v-model="paper.exclude">
                        <Radio label="no">不排除</Radio>
                        <Radio label="yes">排除</Radio>
                      </RadioGroup>
                    </div>
                  </FormItem>

                  <div class="total">
                    <div class="label">字数统计信息</div>
                    <div class="show">
                      <div class="">
                        <span>当前输入</span
                        ><span class="number red"
                          >{{ checkData.wordCount }}单词</span
                        >
                      </div>
                      <div class="">
                        <span>应拍件数</span
                        ><span class="number green"
                          >{{ checkData.number }}件</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <div class="info">
                      <span>英文单词低于300或者大于30000或者其他语言时，官网不出ai报告！</span>
                      <span>您提交的论文不会收录到系统，请放心检测！</span>
                    </div>
                    <div class="subbtn">
                      <FormItem>
                        <Button class="next_step" @click="handleSubmit('paper')"
                          >下一步</Button
                        >
                      </FormItem>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>

        <div class="check-box" v-if="showCheck">
          <CheckPopup
            :checkData="checkData"
            :paperData="paperData"
            @closePopup="closePopup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckPopup from "../../components/checkpopup/checkpopup.vue";

export default {
  components: { CheckPopup },
  data() {
    return {
      taobaolink: "",
      isdis: false,
      loadingStatus: false,
      showCheck: false,
      file: null,
      paper: {
        title: "",
        surname: "",
        name: "",
        type: "file",
        textarea: "",
        exclude: "yes"
      },
      checkData: {
        wordCount: 0,
        number: 0,
      },
      succData: {
        sucYes: false,
      },
      paperData: {},
      ruleValidate: {
        title: [{ required: true, message: "文章标题必填", trigger: "blur" }],
        surname: [{ required: true, message: "作者姓氏必填", trigger: "blur" }],
        name: [{ required: true, message: "作者名称必填", trigger: "blur" }],
      },
    };
  },
  watch: {
    "paper.textarea": {
      handler(newVal, oldVal) {
        var length = newVal.length;
        this.checkDataFun(1, newVal);
      },
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      var params = {
        shop: "Biyeguo",
      };
      this.http
        .post(this.api.getConfig, params)
        .then((res) => {
          console.log(res);
          console.log(res.data);
          // 循环遍历，当explain是“商家店铺”的时候，就是淘宝链接
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].shop == "Biyeguo") {
              this.taobaolink = res.data[i].shop_url;
              this.contractlink = res.data[i].contract_url;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    contactWW() {
      //var href="http://amos.im.alisoft.com/msg.aw?v=2&uid=毕业果旗舰店&site=cntaobao&s=1&charset=utf-8";
      //var href =
      //  "http://amos.alicdn.com/msg.aw?v=2&uid=tb74725969&site=cnalichn&s=10&charset=gbk";
      //window.open(href, "_blank");
      window.open(this.contractlink, "_blank");
    },
    toTaobao() {
      // var taobaolink = 'https://detail.tmall.com/item.htm?abbucket=0&id=701741298341&ns=1&spm=a21n57.1.0.0.1c6d523cLyEfv2';
      // var taobaolink = this.taobaolink;
      window.open(this.taobaolink, "_blank");
    },
    showClick() {
      this.$router.push({ name: "chakanbaogao" });
    },
    checkDataFun(type, newVal = "", file = "") {
      let formData = new FormData();
      formData.append("type", type);
      formData.append("content", newVal);
      formData.append("file", file);
      formData.append("shop","");
      this.succData.sucYes =false;
      if (file.size/1024/1024 > 50){
        this.succData.sucYes = "large";
        this.file = "";
        this.$Message["error"]({
            background: true,
            //content: res.data.msg,
            content: "文章超过50M，请缩小文档后重新提交！",
          });
        console.log(error);
        //return false;
      }
      this.http
        .post(this.api.calData, formData)
        .then((res) => {
          let { code, data } = res.data;
          if (code == 200) {
            this.succData.sucYes = true;
            this.checkData.wordCount = data.word_count;
            this.checkData.number = data.number;
          }else{
            this.succData.sucYes = "no";
          }
        })
        .catch((error) => {
          this.succData.sucYes ="no";
          console.log(error);
        });
    },
    handleUpload(file) {
      this.file = file;
      this.checkDataFun(2, "", file);
      return false;
    },
    typeChange(e) {
      this.checkData = {
        wordCount: 0,
        number: 0,
      };
      if (e == "file") {
        this.paper.textarea = "";
        this.isdis = false;
      } else {
        this.file = null;
        this.isdis = true;
      }
    },
    closePopup() {
      (this.paper = {
        title: this.paper.title,
        surname: this.paper.surname,
        name: this.paper.name,
        type: this.paper.type,
        textarea: this.paper.textarea,
        exclude: this.paper.exclude,
      }),
        (this.checkData = this.checkData),
        (this.file = this.file),
        (this.showCheck = false);
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.showCheck = true;
          var type = 1;
          if (this.paper.type == "file") {
            type = 2;
            if (this.file == null) {
              this.$Message["error"]({
                background: true,
                content: "请选择文件！",
              });
              return false;
            }
          } else if (this.paper.textarea.length == 0) {
            this.$Message["error"]({
              background: true,
              content: "文章内容不能为空！",
            });
            return false;
          }
          this.paperData = {
            title: this.paper.title,
            type: type,
            content: this.paper.textarea,
            file: this.file,
            firstName: this.paper.surname,
            lastName: this.paper.name,
            exclude: this.paper.exclude,
          };
        } else {
          this.showCheck = false;
          //this.$Message.error('Fail!');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">

.page {
  //background-color: hsl(216, 33.3%, 97.1%);
  background-color: hsl(216, 33.3%, 97.1%);
  //background-image: url("../../assets/ce7ff01aba72f7404e311255ef4f789c.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .toptitle {
    color: hsl(207, 82%, 32%);
    font-size: 40px;
    //margin: 0 auto 1rem;
    text-align: left;
  }
  .section {
    .section_2 {
      padding: 2.75rem 0 4.5rem;
      //background-color: hsla(0, 0%, 0%, 0.3);
      //backdrop-filter: blur(0.13rem);
      .group {
        width: 100%;
        max-width: 75rem;
        margin: 0 auto;
        padding: 0 1rem;
        .group_2 {
          padding-bottom: 1.5rem;
          border-bottom: solid 0.13rem hsl(207, 82%, 32%);
          .text-wrapper {
            padding: 0.75rem 0;
            background-color: hsl(207, 82%, 32%);
            border-radius: 0.5rem 0px 0px 0.5rem;
            width: 6.38rem;
            height: 2.5rem;
            border: solid 0.063rem hsl(207, 82%, 32%);
            .text {
              color: hsl(0, 0%, 100%);
            }
          }
          .text-wrapper_2 {
            cursor: pointer;
            padding: 0.75rem 0;
            background-color: hsla(0, 0%, 100%, 0.3);
            border-radius: 0px 0.5rem 0.5rem 0px;
            width: 6.38rem;
            height: 2.5rem;
            .text_2 {
              color: hsl(207, 82%, 32%);
              line-height: 0.91rem;
            }
          }
          .font_1 {
            font-size: 1rem;
            //font-family: PingFang HK;
            line-height: 0.94rem;
          }
          .section_4 {
            margin-top: 0.5rem;
            padding: 0.5rem 1.38rem 0.5rem 1.5rem;
            background-color: hsla(0, 0%, 0%, 0.3);
            border-radius: 0.25rem;
            height: 2rem;
            .section_5 {
              margin-left: 0.88rem;
              background-color: hsla(0, 0%, 100%, 0.3);
              border-radius: 0.25rem;
              width: 0.063rem;
              height: 1rem;
            }
            .image_01 {
              width: 1rem;
              height: 1rem;
            }
            .image_2 {
              margin-left: 1rem;
            }
            .text_3 {
              margin-left: 0.25rem;
            }
          }
        }
        .section_6 {
          padding: 4rem 0 34.75rem;
          background-color: hsl(0, 0%, 100%);
          border-radius: 0.25rem;
          &.nocheck {
            padding: 0;
          }
          .section_8 {
            background-color: hsl(207, 82%, 32%);
            box-shadow: 0px 0.75rem 0.63rem hsla(207, 82%, 32%);
            border-radius: 50%;
            width: 2.5rem;
            height: 2.5rem;
          }
        }
        .article-box {
          .ivu-form .ivu-form-item-label {
            color: #000000;
          }
          padding: 3rem 5rem;
          width: 100%;
          .fileradio {
            margin-bottom: 1.5rem;
          }
          .uploadfile {
            margin: 1rem 0;
          }
          .selectfile {
            background: #16639a;
            border-color: #16639a;
            color: #ffffff;
            padding: 0 1.5rem;
          }
          .disfile .selectfile {
            background: #e6e8eb;
            border-color: #d4d6d9;
            color: #bbbdbf;
          }
          .next_step {
            background: #16639a;
            border-color: #16639a;
            color: #ffffff;
            padding: 0 1.5rem;
          }
          .leftline {
            position: relative;
            border-left: thin solid #d4d6d9;
            padding-left: 3rem;
          }
          .one,
          .two,
          .three {
            background-color: #ffffff;
            background-image: url("../../assets/one.jpg");
            background-repeat: no-repeat;
            width: 2.5rem;
            height: 3rem;
            position: absolute;
            left: -1.3rem;
            top: 0;
          }
          .two {
            background-image: url("../../assets/two.jpg");
            top: -1rem;
          }
          .three {
            background-image: url("../../assets/three.jpg");
            top: unset;
            bottom: 0;
            background-position: bottom;
          }
          .total {
            position: absolute;
            right: 0;
            top: 0;
            .label {
              color: #000000;
              font-size: 14px;
            }
            .show {
              div {
                display: inline-block;
                /* width: 5.4rem; */
                height: 5.5rem;
                border: 1px dashed #0d3e61;
                border-radius: 5px;
                box-sizing: border-box;
                text-align: center;
                padding: 1rem 1rem;
                margin: 1rem 0;
                margin-right: 1rem;
                color: #737373;
                span {
                  display: block;
                  &.number {
                    font-size: 20px;
                    color: #16639a;
                    &.green {
                      color: #16639a;
                    }
                  }
                }
              }
            }
          }
          .flex {
            display: flex;
            padding-top: 0.3rem;
            .info {
              flex: 1;
              span {
                display: block;
                color: #1fb176;
              }
            }
            .subbtn {
              flex: 0;
            }
          }
        }
      }
      .space-y-26 {
        & > *:not(:first-child) {
          margin-top: 1.63rem;
        }
      }
      .font_2 {
        font-size: 0.88rem;
        //font-family: PingFang SC;
        line-height: 0.81rem;
        color: hsl(0, 0%, 100%);
      }
    }
  }
}
@media (max-width: 768px) {
  .page .section .section_2 {
    .group {
      .article-box {
        padding: 2rem 1rem;
        .leftline {
          border: none;
          padding: 0;
        }
        .one,
        .two,
        .three {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 550px) {
  .page .section .section_2 {
    .group {
      .article-box {
        .total {
          position: unset;
        }
      }
    }
  }
}
</style>
